// extracted by mini-css-extract-plugin
export default {"locationSelectorContainer":"context-provider_locationSelectorContainer__NRoEF","title":"context-provider_title__ivp9C","subTitle":"context-provider_subTitle__T6mfm"};